var exports = {
  "g": "xa15a2ab7--ae2b3e--center",
};

module.exports = exports;
